import { useState, useEffect } from 'react';
import { listenPageContent } from '../functions/firebase/siteContent';

export const useSiteContent = (pageId) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    try {
      const unsubscribe = listenPageContent(pageId, (content) => {
        setData(content);
        setLoading(false);
        setError(null);
      });

      return () => {
        unsubscribe();
      };
    } catch (err) {
      setError(err);
      setLoading(false);
    }
  }, [pageId]);

  return { data, loading, error };
};
